import { FC, SVGProps } from 'react';

export const ArrowUpIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M25.3368 21.8132C25.7859 22.2623 26.5141 22.2623 26.9632 21.8132C27.4123 21.3641 27.4123 20.636 26.9632 20.1869L16.9632 10.1869C16.7475 9.9712 16.455 9.85004 16.15 9.85004C15.845 9.85004 15.5525 9.9712 15.3368 10.1869L5.33683 20.1869C4.88772 20.636 4.88772 21.3641 5.33683 21.8132C5.78593 22.2623 6.51407 22.2623 6.96317 21.8132L16.15 12.6264L25.3368 21.8132Z"
			fill="currentColor"
		/>
	</svg>
);
